import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from "react-redux";

import { CssVarsProvider } from '@mui/joy/styles';
import GlobalStyles from '@mui/joy/GlobalStyles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel, { formLabelClasses } from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import theme from '../../../utils/theme';
import { Avatar, Card, CircularProgress, DialogContent, DialogTitle, Modal, ModalClose, ModalDialog } from '@mui/joy';

import { Link, useNavigate } from 'react-router-dom';

import { loginRequest, loginReset, forgetPasswordRequest, resetForgetPassword } from '../../../store/actions'


import image from '../../../constant/image';
import { NAVIGATE_TO_DASHBOARD, NAVIGATE_TO_LOGINPAGE } from '../../../route/types';
import { toast } from 'react-toastify';
import { STATUS } from '../../../constant';
import { LoadingView } from '../../../components';

interface FormElements extends HTMLFormControlsCollection {
    email: HTMLInputElement;
}
interface SignInFormElement extends HTMLFormElement {
    readonly elements: FormElements;
}

const ForgetPassword = ({
    status,
    errorMessage
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (status === STATUS.SUCCESS) {
            toast.success("Password reset successful. New password will be send to your email.")
            setTimeout(() => {
                navigate(NAVIGATE_TO_LOGINPAGE)
            }, 1000)
            dispatch(resetForgetPassword());
        }
        else if (status === STATUS.ERROR) {
            toast.error(errorMessage)
            dispatch(resetForgetPassword());
        }
    })


    const handleSubmit = (event) => {
        event.preventDefault();
        const formElements = event.currentTarget.elements;
        const data = {
            email: formElements.email.value,
        };
        if (data.email != "") {
            const datas = {
                "email": data.email
            }
            dispatch(forgetPasswordRequest(datas))
        } else {
            toast.error("Please enter your email");
        }
    }

    const checkLoading = () => {
        if (status === STATUS.LOADING) {
            return true
        } else {
            return false
        }
    }
    return (
        <CssVarsProvider defaultMode="light" disableTransitionOnChange theme={theme}>
            <CssBaseline />
            <GlobalStyles
                styles={{
                    ':root': {
                        '--Collapsed-breakpoint': '769px', // form will stretch when viewport is below `769px`
                        '--Cover-width': '50vw', // must be `vw` only
                        '--Form-maxWidth': '600px',
                        '--Transition-duration': '0.4s', // set to `none` to disable transition
                    },
                }}
            />

            {/* loading  */}
            <LoadingView loading={checkLoading()} />

            <Box
                sx={(theme) => ({
                    //   width: '90%',
                    transition: 'width var(--Transition-duration)',
                    transitionDelay: 'calc(var(--Transition-duration) + 0.1s)',
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage:
                        `url(${image.Images.backgroung})`,
                    [theme.getColorSchemeSelector('dark')]: {
                        backgroundImage:
                            `url(${image.Images.backgroung2})`,
                    },
                })}
            >

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100dvh',
                        // width:
                        //   'clamp(var(--Form-maxWidth), (var(--Collapsed-breakpoint) - 100vw) * 999, 100%)',
                        maxWidth: '100%',
                        px: 2,
                    }}
                >
                    <Box
                        component="header"
                        sx={{
                            py: 4,
                            gap: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            alignSelf: 'center'
                        }}
                    >
                        <Avatar
                            src={image.Images.logo}
                            size='sm'
                            sx={{
                                width: 180, height: 180, borderRadius: 10, backgroundColor: 'transparent',
                            }}
                        />
                    </Box>
                    <Card
                        component="main"
                        sx={{
                            my: 'auto',
                            py: 2,
                            pb: 5,
                            p: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            width: 400,
                            maxWidth: '100%',
                            mx: 'auto',

                            backgroundColor: 'background.body',
                            borderRadius: 'sm',
                            '& form': {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                            },
                            [`& .${formLabelClasses.asterisk}`]: {
                                visibility: 'hidden',
                            },
                        }}
                    >
                        <Stack gap={4} sx={{ mb: 1 }}>
                            <Stack gap={1}>
                                <Typography level="h3">Forget Password</Typography>
                                <Typography level='body-sm'>Please enter your email you use for login to reset password.</Typography>
                            </Stack>
                        </Stack>
                        <Divider
                            sx={(theme) => ({
                                [theme.getColorSchemeSelector('light')]: {
                                    color: { xs: '#FFF', md: 'text.tertiary' },
                                    '--Divider-lineColor': {
                                        xs: '#FFF',
                                        md: 'var(--joy-palette-divider)',
                                    },
                                },
                            })}
                        >
                            Or
                        </Divider>

                        <Typography level="body-sm" sx={{ textAlign: 'center' }}>
                            Back to{' '}
                            <Link to={NAVIGATE_TO_LOGINPAGE} style={{ textDecoration: 'none' }}>
                                <Typography level='body-sm' sx={{ color: 'blue' }}>Login</Typography>
                            </Link>
                        </Typography>

                        <Stack component='form' onSubmit={handleSubmit} gap={4} sx={{ mt: 1 }}>
                            <FormControl required>
                                <FormLabel>Email</FormLabel>
                                <Input type="text" name="email" placeholder='Enter email' />
                            </FormControl>
                            <Stack gap={1} sx={{ mt: 1 }}>

                                <Button type="submit" fullWidth>
                                    Submit
                                </Button>
                            </Stack>
                        </Stack>
                    </Card>
                    <Box component="footer" sx={{ py: 3 }}>
                        <Typography level="body-xs" textAlign="center" sx={{ color: 'whitesmoke' }}>
                            © Sava Tanzania {new Date().getFullYear()}
                        </Typography>
                    </Box>
                </Box>
            </Box>

        </CssVarsProvider>
    );
}

const mapStateToProps = ({ auth }) => {
    const {
        forgetPasswordStatus: status,
        forgetPasswordErrorMessage: errorMessage
    } = auth

    return {
        status,
        errorMessage
    }
}

// export default LoginPage
export default connect(mapStateToProps, {})(ForgetPassword)